// @flow
import { Box, Button, Container } from '@material-ui/core';
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { applyStyles } from './styles';

const ApplySection = () => {
  const classes = applyStyles({});

  return (
    <Box className={classes.container}>
      <Container maxWidth="md" className={classes.wrapper}>
        <Button
          size="small"
          component={GatsbyLink}
          to="/merchant/application/#documents"
          color="primary"
          variant="contained"
          className={classes.button}
        >
          導入のお申し込みはこちら
        </Button>
        <Box className={classes.materials}>
          <Button
            size="small"
            component={GatsbyLink}
            to="/merchant/materials/sales/"
            color="primary"
            variant="contained"
            className={classes.button}
          >
            資料請求
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default ApplySection;
